<header #CustomDragger mat-dialog-title>
  <div style="display: flex; justify-content: space-between; align-items: baseline;">
    <h2 class="mat-h2">Buscar metas - {{categoriaActual}}</h2>
    <button mat-icon-button class="" (click)="cerrar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</header>
<mat-dialog-content class="modal-central-container">
  <div *ngIf="{data :guardando$ | async} as guardando">
    <mat-progress-bar  *ngIf="guardando.data" mode="indeterminate"></mat-progress-bar>
  </div>
  <div *ngIf="{data:metas$ | async} as metas">
    <div class="mensaje-inicial" *ngIf="metas.data === null;">
      <img src="../assets/mapping-import-goals.png">
      <p>Inicie la importación de metas definiendo<br>los parámetros de búsqueda deseados.</p>
    </div>
    <div class="buscar">
      <div class="buscar-form">
        <app-mapa-meta-buscar-form 
          [categorias]="categorias"
          [materias]="materias"
          [grados]="grados"
          [ambitos]="ambitos"
          [tags]="tags"
          [form]="form">
        </app-mapa-meta-buscar-form>
        <!-- <div *ngIf="{data :guardando$ | async} as guardando" style="display: flex; justify-content: center;">
          <button color="primary" mat-raised-button (click)="buscar()" [disabled]="guardando.data">{{metas.data ? 'Nueva busqueda' : 'Buscar'}}</button>
        </div> -->
      </div>
    </div>
    <div class="buscar-resultados">
      <div *ngIf="metas.data !== null;">
        <app-mapa-metas-resultado
          [metas$]="metas$"
          [categorias]="categorias"
          [materias]="materias"
          [grados]="grados"
          [ambitos]="ambitos"
          [tags]="tags"
          [guardando$]="guardando$"
          [metasAImportar]="metasAImportar"
          [filterForm]="form"
          (cerrarEvent)="cerrar()"
          ></app-mapa-metas-resultado>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="{data:metas$ | async} as metas">
  <div *ngIf="{data :guardando$ | async} as guardando" class="acciones-ajuste">
    <button mat-button (click)="cerrar()">Cancelar</button>
    <button color="primary" mat-raised-button (click)="buscar()" [disabled]="guardando.data">{{metas.data ? 'Nueva busqueda' : 'Buscar'}}</button>
    <button color="primary" mat-raised-button (click)="importar()" [disabled]="guardando.data || metasAImportar.length === 0">Importar</button>
  </div>
</mat-dialog-actions>
